import { useContext, useEffect, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import AuthContext from "../context/AuthContext";
import { RxCross2 } from "react-icons/rx";
import { Button } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegClock } from "react-icons/fa";

const CalendarComponent = () => {
  const { setShowDate, plDate, setPlDate, showDate } = useContext(AuthContext);
  const reset = () => {
    setShowDate({ status: false, type: "" });
  };

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    setPlDate((prev) => {
      return [
        {
          ...prev,
          key: prev?.key,
          startDate: start,
          endDate: end,
        },
      ];
    });
  };
  useEffect(() => {
    setStartDate(plDate[0]?.startDate);
    setEndDate(plDate[0]?.endDate);
  }, [plDate]);
  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        reset();
      }}
    >
      <div
        className={`market-depth-modal calendar-market ${
          showDate?.type !== "Calendar" ? "calendar-market-during" : ""
        }`}
      >
        <div className="market-title">
          <h4 style={{ color: "white" }}>
            {showDate?.type == "Calendar" ? "Select Date" : showDate?.type}
          </h4>
          <Button
            onClick={reset}
            className="border-0 abc text-white position-absolute end-0 top-0 pt-1 fs-4 bg-transparent border-0"
          >
            <RxCross2 />
          </Button>
        </div>
        <div
          style={showDate?.type != "During" ? { paddingTop: "20px" } : {}}
          className="d-flex justify-content-center align-items-center w-100"
        >
          {showDate?.type == "During" ? (
            <div className="p-2 calendar-button">
              <Button
                onClick={() => {
                  setPlDate([
                    {
                      startDate: new Date(),
                      endDate: new Date(),
                      key: "selection",
                    },
                  ]);
                  reset();
                }}
              >
                Today
              </Button>
              <Button
                onClick={() => {
                  setPlDate([
                    {
                      startDate: moment(new Date()).subtract(1, "days")._d,
                      endDate: new Date(),
                      key: "selection",
                    },
                  ]);
                  reset();
                }}
              >
                From Yesterday
              </Button>
              <Button
                onClick={() => {
                  {
                    setPlDate([
                      {
                        startDate: moment(new Date()).subtract(7, "days")._d,
                        endDate: new Date(),
                        key: "selection",
                      },
                    ]);
                    reset();
                  }
                }}
              >
                Last 7 Days
              </Button>
            </div>
          ) : (
            // <DateRange
            //   editableDateInputs={false}
            //   showDateDisplay={false}
            //   maxDate={new Date()}
            //   onChange={(item) => {
            //     setPlDate([item.selection]);
            //   }}
            //   moveRangeOnFirstSelection={false}
            //   ranges={plDate}
            //   rangeColors={["#9CB1BD"]}
            // />
            // <DateRangePicker
            //   value={value}
            //   selectionType='range'
            //   onSelect={change}
            //   maximumDate={new Date()}
            // />

            <DatePicker
              swapRange
              selected={startDate}
              onChange={onChange}
              startDate={startDate}
              endDate={endDate}
              // excludeDates={[addDays(new Date(), 1), addDays(new Date(), 5)]}
              selectsRange
              selectsDisabledDaysInRange
              inline
              maxDate={new Date()}
            />
          )}
        </div>
        {showDate?.type == "Calendar" && (
          <div
            style={{ marginTop: "10px" }}
            className="d-flex justify-content-center align-items-center w-100"
          >
            <p
              style={{
                background: "rgb(212 224 229/1)",
                borderRadius: "5px",
                padding: "8px 14px",
              }}
              className="d-flex w-75 align-items-center"
            >
              <FaRegClock color="rgb(156 177 189/1)" size={21} />{" "}
              <span
                style={{
                  fontSize: "1.0714285714285714rem",
                  color: "black",
                  marginLeft: "10px",
                }}
              >
                09:30 am - 09:29 am
              </span>
            </p>
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default CalendarComponent;
